import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login/Login";
import Layout from "../components/Layout/Layout";
import Menu from "./Menu";
import QrForm from "../pages/QrCode/Form";
import FormMain from "../pages/FeedbackForm/FormMain";
import RejectFeedbackForm from "../pages/FeedbackForm/RejectFeedbackForm";
import ClientFeedbackForm from "../pages/FeedbackForm/ClientFeedbackForm";
import FeedbackSubmit from "../pages/FeedbackForm/FeedbackSubmit";
import FeedbackSkip from "../pages/FeedbackForm/FeedbackSkip";
import FeedbackNeverAsk from "../pages/FeedbackForm/FeedbackNeverAsk";
import DisplayQRCode from "../pages/QrCode/displayQr";
import QRFormSubmit from "../pages/QrCode/QRFormSubmit";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import TaskDetails from "../pages/TaskManagement/TaskDetails";

const Routing = () => {
  return (
    <Routes>
      {Menu.map((el, ind) => (
        <Route
          key={ind}
          path={el.path}
          element={
            <Layout>
              <el.element />
            </Layout>
          }
        />
      ))}
      <Route path="/login" element={<Login />} />
      <Route path="/privacyPolicy" element={<PrivacyPolicy />} />

      <Route path="/qrform" element={<QrForm />} />
      <Route path="/feedbackForm" element={<FormMain />} />
      <Route path="/rejectFeedbackForm" element={<RejectFeedbackForm/>} />
      <Route path="/clientFeedbackForm" element={<ClientFeedbackForm />} />
      <Route path="/feedbackSubmit" element={<FeedbackSubmit />} />
      <Route path="/feedbackSkip" element={<FeedbackSkip />} />
      <Route path="/feedbackNeverAsk" element={<FeedbackNeverAsk />} />
      <Route path="/qrFormSubmit" element={<QRFormSubmit />} />
      <Route path="/taskDetails" element={<Layout><TaskDetails /></Layout>} />
    </Routes>
  );
};

export default Routing;
